import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Název',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Popis',
    field: 'description',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Vytvořeno',
    field: 'created',
    type: ColumnType.DATE,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/modules/roles-create/_rolesCreateColumns.ts